// import moment from "moment";
import moment from "moment-timezone";

moment.tz.setDefault("UTC");

export default moment;
